import TableInner from "Areas/Documents/table/table.inner/table.inner";
import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import usePrevious from "Common/componentUtils/usePrevious";
import { themeVariables } from "Components/theme";
import WithModal from "Components/withModal";
import React, { useCallback, useEffect, useState } from "react";
const SIZES = {
    MODAL_DEFAULT_HEIGHT: `calc(100vh - ${parseInt(themeVariables["panel-body-padding"]) * 5}px)`,
    MODAL_DEFAULT_WIDTH: `calc(100vw - ${parseInt(themeVariables["panel-body-padding"]) * 5}px)`,
    PREVIEW_MIN_WIDTH: 100
};
const defaultSettings = {
    alignment: "text-left",
    fontSize: "font-base",
    hiddenColumns: []
};
export function GroupNodeTable(props) {
    var _a;
    const [isOpen, setIsOpen] = useState(false);
    const [showCompleted, setShowCompleted] = useState(false);
    const [data, setData] = useState();
    const [columns, setColumns] = useState();
    const prevGroupData = usePrevious(props.groupData);
    useEffect(() => {
        setIsOpen(Boolean(props.isOpen));
        props.isOpen && setShowCompleted(false);
        if (props.isOpen && prevGroupData !== props.groupData) {
            setData(undefined);
            setColumns(undefined);
        }
    }, [props.isOpen]);
    useEffect(() => {
        if (!props.documentId || !props.groupData)
            return;
        props.onGetTableData &&
            props.onGetTableData(props.documentId, props.groupData.NodeIds, (respData, respColumns) => {
                setData(respData);
                setColumns(respColumns);
            });
    }, [props.groupData, props.documentId]);
    const handleHide = useCallback(() => {
        setIsOpen(false);
        props.onClose && props.onClose();
    }, [props.onClose]);
    const handleShow = useCallback(() => {
        setShowCompleted(true);
    }, [props.onClose]);
    const handleGetPreview = useCallback((_, __, _$, largeAttributeId, completed, rejected) => {
        if (largeAttributeId) {
            props.onGetPreview(largeAttributeId, completed, rejected);
        }
        else {
            rejected && rejected();
        }
    }, [props.onGetPreview]);
    return (React.createElement(WithModal, { showTitle: true, closeBtn: true, show: isOpen, title: (_a = props.groupData) === null || _a === void 0 ? void 0 : _a.GroupName, hideOnOutsideClick: true, onHide: handleHide, onShow: handleShow, shadingColor: shadingLightestColor, className: "bg-blur", defaultWidth: SIZES.MODAL_DEFAULT_WIDTH, defaultHeight: SIZES.MODAL_DEFAULT_HEIGHT, isLoading: props.inProgress },
        React.createElement("div", { className: "pt-0_25 panel-body-pr panel-body-pb panel-body-pl" }, data && columns && showCompleted && (React.createElement(TableInner, { documentId: props.documentId, documentObjects: props.documentObjects, data: data, height: "100%", columns: columns, settings: defaultSettings, minRowHeight: 30, imageWidgetSize: 28, onGetPreview: handleGetPreview, zIndex: parseInt(themeVariables["zindex-pageheader-menu"]) + 6 })))));
}
